import Configs from '../../../config.js';
import { TableColumn, TableColumns } from '../../../components/_tables/TableColumns';
import moment from 'moment';


// Map Data to Desired Display Values
function presentData(data) {

    return data.map(d => {
        d.createdOn = moment(d.createdOn).format(Configs.formats.dateTime);

        return d;
    });
}

// Table Pagination Columns Scheme
function tableColumnDefinitions() {

    const idCol = new TableColumn()
        .setKey('id')
        .setDisplayName('#')

    const codeCol = new TableColumn()
        .setKey('code')
        .setDisplayName('Code')
        .setEditKey('code')

    const descriptionCol = new TableColumn()
        .setKey('description')
        .setDisplayName('Description')
        .setEditKey('description')

    const tagsCol = new TableColumn()
        .setKey('tags')
        .setDisplayName('Common Terms')
        .setEditKey('tags')

    const tableCols = new TableColumns([
        codeCol,
        descriptionCol,
        tagsCol
    ])

    return tableCols;

}

/**
 * Exports
 */
export {
    presentData,
    tableColumnDefinitions
}